module.exports = __webpack_public_path__ + "static/img/2.a0dd702.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/eng/2.png
// module id = HzYc
// module chunks = 0